import { defineStore } from 'pinia';
import type { dynamicObj } from 'src/pages/assets';
import { userAndSupplierGroupMapping } from 'src/services';
import { ref } from 'vue';

export const useUserSupplierGroupMappingStore = defineStore(
  'user_supplier_group_mapping',
  {
    state: () => ({
      supplier_group_mapping_list: [] as dynamicObj[],
      existing_users: [] as any,
      existing_group: [] as any,
      list_user_option: [] as any,
      list_group_option: [] as dynamicObj,
      user_id: ref(''),
      group_id: ref(''),
      supplier_group_id: ref(''),
      loading: false,
      dialog: false,
      confirmDeleteDialog: false,
      userOrGroupValue: ref(''),
      userOrGroupList: [
        { label: 'User', value: 'user' },
        { label: 'Group', value: 'group' },
      ],
    }),
    actions: {
      async getUserSupplierGroupMappingAsSelectList() {
        this.loading = true;
        try {
          const response =
            await userAndSupplierGroupMapping.getUserSupplierGroupMapping();
          if (response.length !== 0) {
            this.supplier_group_mapping_list = response;
          }
        } catch (error) {
          logError(error);
          this.loading = false;
        }
        this.loading = false;
      },
      async getUserlist() {
        const response = await userAndSupplierGroupMapping.getUserlist();
        this.list_user_option = [];
        for (const user of response) {
          if (
            this.existing_users == null ||
            !this.existing_users.find(
              (existing_user: any) => existing_user.user_id === user.id,
            )
          )
            this.list_user_option.push({
              label: user.first_name + ' ' + user.last_name,
              value: user.id.toString(),
            });
        }
        this.user_id = '';
      },
      async getGroupList() {
        const response = await userAndSupplierGroupMapping.getGroups();
        this.list_group_option = [];
        if (response && response.length > 0) {
          for (const group of response) {
            if (
              !this.existing_group ||
              !this.existing_group.find(
                (existing_group: any) => existing_group.id === group.id,
              )
            ) {
              this.list_group_option.push({
                label: group.name,
                value: group.id.toString(),
              });
            }
          }
        } else {
          this.list_group_option = [];
        }
      },
      async addUserSupplierGroupMapping(): Promise<void> {
        this.loading = true;
        const newForm = new FormData();
        newForm.append('user_id', this.user_id);
        newForm.append('group_id', this.group_id);
        newForm.append('supplier_group_id', this.supplier_group_id);

        try {
          const response =
            await userAndSupplierGroupMapping.addUserSupplierGroupMapping(
              newForm,
            );
          if (response.success === false) {
            throw response;
          }
          this.getUserSupplierGroupMappingAsSelectList();
        } catch (error) {
          throw error;
        } finally {
          this.loading = false;
        }
      },
      async deleteUserSupplierGroupMapping(): Promise<void> {
        this.loading = true;
        const formData = new FormData();
        formData.append('user_id', this.user_id);
        formData.append('group_id', this.group_id);
        formData.append('supplier_group_id', this.supplier_group_id);

        try {
          const response =
            await userAndSupplierGroupMapping.deleteUserSupplierGroupMapping(
              formData,
            );
          if (response.success === false) {
            throw response;
          }
          this.getUserSupplierGroupMappingAsSelectList();
        } catch (error) {
          throw error;
        } finally {
          this.loading = false;
        }
      },
    },
  },
);
